// extracted by mini-css-extract-plugin
export default {"toggleButton":"style_toggleButton__ZF4AB"};